export default class Realisation {
    constructor($elts) {
        this.$img = $elts;
        this.$gallery = document.querySelector('[data-role="realisation-gallery"]')
        this.$item = this.$gallery.querySelectorAll('a');
        this._init();
    }

    _init() {

        this._setDataAttributes();

        this.$item.forEach(a => {
            a.addEventListener('click', this._setDataAttributes.bind(this));
        })

        const lightbox = new PhotoSwipeLightbox({
            gallery: this.$gallery,
            children: 'a',
            mainClass: 'brx',
            pswpModule: PhotoSwipe5 // correspond au fichier photoswipe.umd.min.js
          });
          
        // ajout de caption
        lightbox.on('uiRegister', function() {
            lightbox.pswp.ui.registerElement({
                name: 'custom-caption',
                order: 9,
                isButton: false,
                appendTo: 'root',
                html: 'Caption text',
                onInit: (el, pswp) => {
                lightbox.pswp.on('change', () => {
                    const currSlideElement = lightbox.pswp.currSlide.data.element;
                    let captionHTML = '';
                    if (currSlideElement) {
                    const hiddenCaption = currSlideElement.querySelector('.hidden-caption-content');
                    if (hiddenCaption) {
                        // get caption from element with class hidden-caption-content
                        captionHTML = hiddenCaption.innerHTML;
                    } else {
                        // get caption from alt attribute
                        captionHTML = currSlideElement.querySelector('img').getAttribute('alt');
                    }
                    }
                    el.innerHTML = captionHTML || '';
                });
                }
            });
        });

        lightbox.init();
    }

    _setDataAttributes() {
        // definit les data attributes necessaires au fonctionnement de photoswipe
        this.$item.forEach((item) => {
            let img = item.querySelector('img');
            let imgSrc = img.getAttribute('src');
            let imgW = img.getAttribute('width');
            let imgH = img.getAttribute('height');
            let largestImgW;
            let largestImgH;
    
            if( img.getAttribute('srcset') ) {
                let srcsetArray = img.srcset.split(',');
                let largestSetArry = this._getLargestImage(srcsetArray);
                imgSrc = largestSetArry[0];
                largestImgW = parseInt(largestSetArry[1].replace('w',''));
                largestImgH = imgH * largestImgW / imgW;
            }
            
            item.dataset.pswpSrc = imgSrc;
            item.dataset.pswpWidth = largestImgW;
            item.dataset.pswpHeight = largestImgH;
        })
    }

    // Function to get the largest image from my img srcset
    _getLargestImage(srcsetArray) {
        let largestSet = srcsetArray.reduce((previousSet, currentSet)=>{
            let temp_p = previousSet.trim().split(' ');
            let width_p = parseInt(temp_p[1].replace('w',''));
            let temp_c = currentSet.trim().split(' ');
            let width_c = parseInt(temp_c[1].replace('w',''));
            return (width_c > width_p)? currentSet: previousSet;
        });
        return largestSet.trim().split(' ');
    }
}